import Vue from "vue";
import {ToastPlugin, ModalPlugin} from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";

import router from "./router";
import store from "./store";
import App from "./App.vue";
import appConfig from "../appConfig";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require("@core/scss/core.scss");

// import assets styles (custom dashboard enhancements)
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;
const activeBimbel = process.env.VUE_APP_BIMBEL;
const isPriorityBrand = activeBimbel === "priority";
Vue.prototype.$logoUrlSvg = `/config/${activeBimbel}/${isPriorityBrand ? "logo-wordmark.png" : "logo.svg"}`;
Vue.prototype.$logoUrlPng = `/config/${activeBimbel}/${isPriorityBrand ? "logo-mark.png" : "logo.png"}`;
Vue.prototype.$appConfig = {
  ...appConfig.bimbelConfig[activeBimbel],
  baseDomain: process.env.VUE_APP_BASE_DOMAIN
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
